import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Add as AddIcon, Remove as RemoveIcon } from '../../icons';
import { IconButton, Typography } from '..';

export interface QuantityControlProps {
  disableRemoveItem?: boolean;
  itemName: string;
  onAddItem: (any) => void;
  onRemoveItem: (any) => void;
  quantity?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  quantityControl: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-end',

    '& .activeQuantity': {
      display: 'none',

      '&--visible': {
        display: 'block',
      },
    },
  },

  quantityValue: {
    minWidth: '24px',
    padding: theme.spacing(0, 0.25),

    '&.fd-text': {
      textAlign: 'center',
    },
  },
}));

export const QuantityControl = (props: QuantityControlProps): JSX.Element => {
  const {
    disableRemoveItem = false,
    itemName,
    onAddItem,
    onRemoveItem,
    quantity = '1',
  } = props;

  const classes = useStyles();
  const translate = (key) => key;

  const quantityControlStyles = clsx(
    'removeItemButton',
    classes.quantityControl,
    quantity > 0 && 'hasQuantity',
  );

  const hasQuantityStyles = clsx(
    quantity === 0 && 'activeQuantity',
    quantity > 0 && 'activeQuantity--visible',
  );
  const quantityValueStyles = clsx(classes.quantityValue, hasQuantityStyles);

  return (
    <div className={quantityControlStyles}>
      <IconButton
        aria-label={`${translate('Remove')} ${itemName}`}
        className={hasQuantityStyles}
        data-fd="quantity-control-remove"
        disabled={disableRemoveItem}
        onClick={onRemoveItem}
      >
        <RemoveIcon size="s" />
      </IconButton>

      <Typography
        className={quantityValueStyles}
        data-fd="quantity-control-value"
        variant="body2"
      >
        {quantity}
      </Typography>

      <IconButton
        aria-label={`${translate('Add')} ${itemName}`}
        className="addItemButton"
        data-fd="quantity-control-add"
        onClick={onAddItem}
      >
        <AddIcon size="s" />
      </IconButton>
    </div>
  );
};
